// ElectricityBudget.js
import React from 'react';
import BudgetElectricityPlot from '../components/Plot/BudgetElectricityPlot';

class ElectricityBudget extends React.Component {
  render() {
    return (
      <div>
        <BudgetElectricityPlot />
      </div>
    );
  }
}

export default ElectricityBudget;